'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var InstabookList = function InstabookList(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("path", {
    fill: "none",
    d: "M0,0h24v24H0V0z"
  }), React__default["default"].createElement("g", {
    transform: "translate(0,-952.36218)"
  }, React__default["default"].createElement("g", null, React__default["default"].createElement("rect", {
    x: "3",
    y: "967.362",
    width: "2",
    height: "2"
  }), React__default["default"].createElement("polygon", {
    points: "12.742,959.362 7,959.362 7,961.362 11.222,961.362 \t\t"
  }), React__default["default"].createElement("rect", {
    x: "3",
    y: "959.362",
    width: "2",
    height: "2"
  }), React__default["default"].createElement("polyline", {
    points: "9.703,963.362 7,963.362 7,965.362 8.203,965.362 \t\t"
  }), React__default["default"].createElement("rect", {
    x: "3",
    y: "963.362",
    width: "2",
    height: "2"
  }), React__default["default"].createElement("polygon", {
    points: "16.557,959.362 15.97,961.362 21,961.362 21,959.362 \t\t"
  }), React__default["default"].createElement("polygon", {
    points: "12.047,967.362 7,967.362 7,969.362 11.402,969.362 \t\t"
  }), React__default["default"].createElement("polyline", {
    points: "18.334,965.362 21,965.362 21,963.362 19.891,963.362 \t\t"
  }), React__default["default"].createElement("polygon", {
    points: "15.21,969.362 21,969.362 21,967.362 16.771,967.362 \t\t"
  })), React__default["default"].createElement("path", {
    d: "M16.466,956.114l-7.287,9.591h4.453l-2.227,6.905l7.49-9.591h-4.452L16.466,956.114z"
  })));
};

var InstabookList$1 = iconStyles()(InstabookList);

module.exports = InstabookList$1;
